module.exports = __webpack_public_path__ + "img/topup.dbd76c2c.svg";